const cyclicVoltaJcamp1 = `
##TITLE=RCV_LSH-R444_full+Fc
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=RCV_LSH-R444_full+Fc
##JCAMP-DX=5.00
##DATA TYPE=CYCLIC VOLTAMMETRY
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=V vs Ref
##YUNITS=A
##XFACTOR=1.0
##YFACTOR=1.0
##FIRSTX=1.49048
##LASTX=1.50049
##MAXX=1.50049
##MAXY=5.34724e-06
##MINX=-1.9005
##MINY=-3.07144e-06
##NPOINTS=680
##XYDATA= (XY..XY)
1.49048, 5.34724e-06
1.48049, 4.81545e-06
1.47048, 4.39585e-06
1.4603, 4.03827e-06
1.45028, 3.75535e-06
1.44028, 3.51137e-06
1.43031, 3.30386e-06
1.42029, 3.12825e-06
1.41033, 2.96791e-06
1.40032, 2.83767e-06
1.39032, 2.72045e-06
1.38033, 2.62302e-06
1.37033, 2.54135e-06
1.36033, 2.46733e-06
1.35033, 2.40966e-06
1.3403, 2.35496e-06
1.3303, 2.30822e-06
1.32031, 2.26844e-06
1.31033, 2.22752e-06
1.30034, 2.19654e-06
1.29034, 2.16149e-06
1.28035, 2.13405e-06
1.27033, 2.10553e-06
1.26032, 2.07961e-06
1.25034, 2.05538e-06
1.24032, 2.03078e-06
1.23036, 2.01071e-06
1.22034, 1.98728e-06
1.21034, 1.96737e-06
1.20034, 1.94665e-06
1.19035, 1.92614e-06
1.18035, 1.9073e-06
1.17035, 1.8869e-06
1.16035, 1.86775e-06
1.15035, 1.84695e-06
1.14034, 1.82693e-06
1.13035, 1.80441e-06
1.12033, 1.78108e-06
1.11032, 1.75485e-06
1.10032, 1.72402e-06
1.09033, 1.68839e-06
1.08033, 1.6432e-06
1.07034, 1.58889e-06
1.06034, 1.51897e-06
1.05034, 1.43413e-06
1.04033, 1.33108e-06
1.03032, 1.21146e-06
1.02033, 1.07999e-06
1.01032, 9.456e-07
1.00035, 8.19646e-07
0.990341, 7.13221e-07
0.980329, 6.36902e-07
0.970335, 6.05514e-07
0.960343, 6.26731e-07
0.950342, 7.32062e-07
0.940326, 8.08074e-07
0.930319, 8.57177e-07
0.920312, 8.95249e-07
0.910339, 9.27491e-07
0.900162, 9.5427e-07
0.890147, 9.783e-07
0.880152, 1.0001e-06
0.870155, 1.02105e-06
0.860151, 1.04076e-06
0.85014, 1.06359e-06
0.840156, 1.08684e-06
0.830131, 1.11634e-06
0.820166, 1.15049e-06
0.81017, 1.19009e-06
0.800172, 1.24084e-06
0.790173, 1.2942e-06
0.780167, 1.35859e-06
0.770192, 1.42621e-06
0.760177, 1.49551e-06
0.750181, 1.56266e-06
0.740178, 1.62763e-06
0.730173, 1.68067e-06
0.720185, 1.72703e-06
0.710158, 1.76093e-06
0.700157, 1.78566e-06
0.690154, 1.79854e-06
0.680178, 1.80587e-06
0.670158, 1.80513e-06
0.660173, 1.79873e-06
0.650178, 1.79063e-06
0.640193, 1.7763e-06
0.630169, 1.76283e-06
0.620162, 1.74476e-06
0.61023, 1.72856e-06
0.60022, 1.70862e-06
0.590243, 1.69044e-06
0.580233, 1.67049e-06
0.570243, 1.65092e-06
0.560236, 1.63209e-06
0.550248, 1.61151e-06
0.540243, 1.59426e-06
0.530231, 1.57533e-06
0.520231, 1.55847e-06
0.51022, 1.54274e-06
0.50023, 1.52674e-06
0.490238, 1.51447e-06
0.480245, 1.49923e-06
0.470239, 1.48777e-06
0.460241, 1.47727e-06
0.450247, 1.46626e-06
0.440264, 1.45967e-06
0.430245, 1.45118e-06
0.420234, 1.44607e-06
0.410254, 1.44173e-06
0.400253, 1.43833e-06
0.390259, 1.43608e-06
0.380252, 1.43528e-06
0.370248, 1.43447e-06
0.360257, 1.43418e-06
0.350255, 1.43714e-06
0.340052, 1.43739e-06
0.330068, 1.43902e-06
0.320059, 1.44191e-06
0.310045, 1.44408e-06
0.300048, 1.44709e-06
0.290041, 1.45125e-06
0.280042, 1.45843e-06
0.270048, 1.4653e-06
0.260057, 1.47367e-06
0.250056, 1.48223e-06
0.240063, 1.48762e-06
0.23007, 1.49184e-06
0.220051, 1.4922e-06
0.21004, 1.48973e-06
0.200028, 1.48204e-06
0.19004, 1.4685e-06
0.180061, 1.44727e-06
0.170051, 1.41664e-06
0.160047, 1.37251e-06
0.150049, 1.31567e-06
0.140039, 1.24166e-06
0.13005, 1.14379e-06
0.120052, 1.01875e-06
0.110043, 8.53735e-07
0.100041, 6.42919e-07
0.0900562, 3.81335e-07
0.0800548, 8.21487e-08
0.0700697, -2.33295e-07
0.0600559, -5.31238e-07
0.0500671, -7.75372e-07
0.0400719, -9.43458e-07
0.0300629, -1.02576e-06
0.0200669, -1.03802e-06
0.0100562, -9.98785e-07
8.57078e-05, -9.26505e-07
-0.00993693, -8.39468e-07
-0.019949, -7.48359e-07
-0.029942, -6.61827e-07
-0.0399388, -5.83075e-07
-0.0499293, -5.11544e-07
-0.0599428, -4.50052e-07
-0.0699406, -3.97695e-07
-0.0799512, -3.52656e-07
-0.0899547, -3.15038e-07
-0.0999457, -2.83275e-07
-0.109946, -2.56812e-07
-0.119946, -2.34741e-07
-0.129933, -2.16077e-07
-0.13992, -2.00744e-07
-0.149939, -1.88102e-07
-0.159937, -1.77259e-07
-0.16993, -1.68371e-07
-0.179952, -1.60664e-07
-0.189945, -1.54502e-07
-0.199948, -1.49314e-07
-0.209926, -1.45132e-07
-0.22013, -1.41864e-07
-0.23011, -1.39051e-07
-0.240124, -1.36834e-07
-0.250135, -1.35183e-07
-0.260126, -1.33911e-07
-0.270119, -1.33135e-07
-0.280088, -1.32681e-07
-0.290129, -1.32736e-07
-0.300117, -1.32878e-07
-0.310125, -1.33365e-07
-0.320122, -1.34226e-07
-0.330112, -1.35209e-07
-0.340106, -1.36298e-07
-0.350098, -1.3757e-07
-0.360105, -1.38854e-07
-0.3701, -1.40326e-07
-0.380112, -1.41737e-07
-0.390089, -1.43349e-07
-0.400119, -1.45086e-07
-0.410093, -1.46751e-07
-0.420101, -1.48434e-07
-0.430105, -1.50035e-07
-0.440087, -1.51479e-07
-0.450092, -1.52804e-07
-0.460085, -1.53997e-07
-0.470098, -1.55187e-07
-0.480082, -1.56113e-07
-0.490089, -1.57042e-07
-0.500117, -1.5804e-07
-0.510095, -1.59069e-07
-0.520107, -1.60079e-07
-0.53012, -1.61246e-07
-0.540116, -1.62451e-07
-0.550087, -1.63909e-07
-0.560093, -1.65532e-07
-0.570088, -1.67128e-07
-0.580104, -1.68932e-07
-0.590105, -1.70771e-07
-0.600101, -1.72755e-07
-0.610116, -1.7461e-07
-0.620115, -1.76398e-07
-0.630107, -1.78412e-07
-0.6401, -1.80284e-07
-0.650105, -1.82219e-07
-0.660113, -1.84029e-07
-0.670105, -1.85924e-07
-0.680122, -1.87821e-07
-0.690095, -1.89658e-07
-0.700122, -1.91524e-07
-0.710107, -1.93279e-07
-0.720106, -1.94812e-07
-0.730092, -1.96467e-07
-0.740086, -1.97953e-07
-0.750096, -1.99417e-07
-0.760097, -2.00979e-07
-0.770109, -2.0247e-07
-0.780275, -2.04314e-07
-0.790286, -2.05634e-07
-0.800283, -2.07125e-07
-0.810281, -2.08442e-07
-0.820281, -2.09905e-07
-0.830276, -2.11478e-07
-0.840277, -2.12932e-07
-0.850262, -2.14479e-07
-0.860261, -2.15891e-07
-0.870251, -2.17506e-07
-0.880259, -2.19075e-07
-0.89024, -2.20338e-07
-0.900262, -2.22075e-07
-0.910284, -2.23508e-07
-0.920271, -2.25163e-07
-0.930275, -2.2663e-07
-0.940282, -2.28122e-07
-0.950275, -2.29651e-07
-0.960257, -2.31158e-07
-0.970256, -2.32689e-07
-0.980264, -2.34333e-07
-0.990254, -2.36003e-07
-1.00028, -2.37673e-07
-1.01026, -2.39419e-07
-1.02024, -2.41441e-07
-1.03024, -2.43552e-07
-1.04024, -2.4586e-07
-1.05021, -2.48324e-07
-1.06021, -2.5113e-07
-1.07022, -2.54262e-07
-1.0802, -2.57648e-07
-1.09022, -2.61741e-07
-1.1002, -2.6579e-07
-1.11022, -2.7045e-07
-1.12022, -2.75363e-07
-1.13021, -2.80379e-07
-1.14021, -2.86748e-07
-1.1502, -2.93263e-07
-1.16022, -3.01411e-07
-1.17022, -3.10781e-07
-1.18021, -3.22016e-07
-1.19022, -3.35124e-07
-1.20021, -3.50539e-07
-1.21021, -3.68111e-07
-1.22021, -3.8824e-07
-1.2302, -4.10535e-07
-1.24019, -4.35781e-07
-1.25019, -4.6301e-07
-1.26018, -4.92192e-07
-1.2702, -5.23028e-07
-1.28018, -5.5571e-07
-1.29018, -5.885e-07
-1.30017, -6.21679e-07
-1.31019, -6.53988e-07
-1.32018, -6.85302e-07
-1.33019, -7.14982e-07
-1.3404, -7.44684e-07
-1.35041, -7.71194e-07
-1.36039, -7.9699e-07
-1.37038, -8.23607e-07
-1.38037, -8.50985e-07
-1.39039, -8.80605e-07
-1.40039, -9.12123e-07
-1.41041, -9.44276e-07
-1.42039, -9.77799e-07
-1.4304, -1.02132e-06
-1.44041, -1.08927e-06
-1.45042, -1.1927e-06
-1.46039, -1.34308e-06
-1.47039, -1.54395e-06
-1.48039, -1.79155e-06
-1.49039, -2.07271e-06
-1.5004, -2.36527e-06
-1.51038, -2.63769e-06
-1.5204, -2.86213e-06
-1.53041, -3.00768e-06
-1.5404, -3.07144e-06
-1.55041, -3.06642e-06
-1.56037, -3.01029e-06
-1.57039, -2.92679e-06
-1.58039, -2.8313e-06
-1.5904, -2.7325e-06
-1.60037, -2.63866e-06
-1.61038, -2.55327e-06
-1.62037, -2.47645e-06
-1.63041, -2.41117e-06
-1.64038, -2.35382e-06
-1.65037, -2.30583e-06
-1.66036, -2.26398e-06
-1.67035, -2.22788e-06
-1.68036, -2.19689e-06
-1.69035, -2.16813e-06
-1.70036, -2.14412e-06
-1.71036, -2.12038e-06
-1.72036, -2.09988e-06
-1.73037, -2.08001e-06
-1.74036, -2.06104e-06
-1.75038, -2.04437e-06
-1.76036, -2.0267e-06
-1.77036, -2.01134e-06
-1.78035, -1.99601e-06
-1.79035, -1.98068e-06
-1.80037, -1.96677e-06
-1.81036, -1.95059e-06
-1.82036, -1.937e-06
-1.83037, -1.92261e-06
-1.84032, -1.90875e-06
-1.85033, -1.89744e-06
-1.8603, -1.88493e-06
-1.87031, -1.87551e-06
-1.88029, -1.8653e-06
-1.89031, -1.85694e-06
-1.9005, -1.8507e-06
-1.8903, -1.8042e-06
-1.8803, -1.7756e-06
-1.87031, -1.75261e-06
-1.86031, -1.73525e-06
-1.85031, -1.72091e-06
-1.84031, -1.70804e-06
-1.83034, -1.69841e-06
-1.82036, -1.6896e-06
-1.81036, -1.68273e-06
-1.80036, -1.67757e-06
-1.79035, -1.67242e-06
-1.78035, -1.66948e-06
-1.77035, -1.66589e-06
-1.76036, -1.66274e-06
-1.75038, -1.66053e-06
-1.74035, -1.65685e-06
-1.73037, -1.65438e-06
-1.72036, -1.65012e-06
-1.71036, -1.64656e-06
-1.70036, -1.64219e-06
-1.69033, -1.63638e-06
-1.68037, -1.63121e-06
-1.67035, -1.62337e-06
-1.66035, -1.61535e-06
-1.65037, -1.60577e-06
-1.64038, -1.59421e-06
-1.6304, -1.57962e-06
-1.62038, -1.562e-06
-1.6104, -1.54019e-06
-1.60038, -1.51179e-06
-1.5904, -1.47638e-06
-1.58039, -1.43106e-06
-1.5704, -1.37492e-06
-1.56038, -1.3075e-06
-1.55042, -1.22921e-06
-1.5404, -1.14431e-06
-1.53041, -1.05503e-06
-1.5204, -9.65333e-07
-1.51039, -8.77321e-07
-1.5004, -7.89674e-07
-1.49039, -7.06926e-07
-1.48039, -6.30146e-07
-1.47039, -5.66015e-07
-1.46039, -5.17304e-07
-1.45042, -4.82527e-07
-1.44041, -4.58242e-07
-1.43041, -4.3915e-07
-1.42039, -4.20918e-07
-1.4104, -4.02545e-07
-1.4004, -3.8395e-07
-1.3904, -3.65714e-07
-1.38037, -3.46991e-07
-1.37037, -3.28446e-07
-1.3604, -3.09508e-07
-1.35041, -2.90518e-07
-1.3404, -2.70988e-07
-1.33019, -2.50884e-07
-1.3202, -2.31797e-07
-1.3102, -2.12517e-07
-1.30019, -1.93851e-07
-1.29021, -1.75498e-07
-1.28019, -1.58051e-07
-1.27021, -1.41216e-07
-1.26019, -1.25349e-07
-1.2502, -1.10518e-07
-1.24019, -9.66574e-08
-1.2302, -8.38218e-08
-1.22022, -7.20816e-08
-1.2102, -6.1077e-08
-1.2002, -5.12298e-08
-1.19021, -4.2293e-08
-1.18021, -3.40883e-08
-1.1702, -2.65997e-08
-1.16022, -2.00459e-08
-1.15022, -1.41216e-08
-1.1402, -8.71463e-09
-1.13023, -4.1584e-09
-1.12023, -5.13163e-12
-1.11022, 3.63771e-09
-1.10021, 6.54954e-09
-1.09022, 9.09781e-09
-1.08022, 1.11135e-08
-1.07023, 1.25647e-08
-1.06022, 1.37466e-08
-1.05022, 1.44717e-08
-1.04025, 1.49478e-08
-1.03025, 1.5099e-08
-1.02025, 1.5027e-08
-1.01028, 1.48071e-08
-1.00029, 1.45076e-08
-0.99027, 1.42184e-08
-0.980278, 1.37939e-08
-0.970273, 1.35044e-08
-0.960265, 1.33236e-08
-0.950277, 1.31012e-08
-0.94029, 1.30576e-08
-0.930279, 1.32065e-08
-0.920277, 1.32908e-08
-0.910283, 1.38074e-08
-0.90026, 1.41723e-08
-0.890256, 1.47253e-08
-0.880273, 1.53739e-08
-0.870258, 1.62241e-08
-0.860272, 1.71212e-08
-0.850268, 1.8016e-08
-0.840278, 1.90256e-08
-0.830279, 2.0132e-08
-0.820306, 2.11601e-08
-0.810309, 2.24038e-08
-0.800303, 2.35495e-08
-0.7903, 2.48709e-08
-0.780287, 2.60994e-08
-0.770102, 2.75989e-08
-0.760096, 2.87872e-08
-0.750094, 3.00931e-08
-0.740088, 3.12901e-08
-0.730099, 3.25483e-08
-0.720113, 3.38335e-08
-0.710111, 3.50656e-08
-0.700121, 3.62822e-08
-0.690092, 3.74743e-08
-0.68011, 3.86853e-08
-0.670098, 3.9866e-08
-0.66012, 4.10241e-08
-0.650107, 4.22612e-08
-0.640118, 4.33202e-08
-0.630119, 4.44825e-08
-0.620136, 4.56474e-08
-0.610133, 4.67679e-08
-0.60012, 4.78815e-08
-0.590108, 4.91054e-08
-0.5801, 5.00968e-08
-0.570096, 5.11431e-08
-0.560087, 5.22948e-08
-0.550085, 5.33286e-08
-0.540107, 5.4444e-08
-0.530113, 5.54306e-08
-0.52012, 5.65887e-08
-0.510103, 5.76321e-08
-0.500124, 5.87065e-08
-0.4901, 5.98317e-08
-0.480066, 6.11228e-08
-0.470092, 6.21271e-08
-0.46009, 6.3207e-08
-0.450114, 6.4313e-08
-0.440103, 6.54505e-08
-0.430114, 6.65547e-08
-0.420106, 6.76943e-08
-0.410107, 6.87203e-08
-0.40013, 6.97804e-08
-0.390124, 7.07251e-08
-0.380129, 7.17297e-08
-0.370107, 7.27407e-08
-0.360123, 7.37097e-08
-0.350133, 7.4626e-08
-0.340115, 7.56853e-08
-0.330119, 7.67162e-08
-0.320129, 7.7876e-08
-0.31013, 7.92213e-08
-0.300136, 8.06853e-08
-0.290128, 8.25409e-08
-0.280116, 8.46371e-08
-0.270123, 8.70069e-08
-0.260142, 8.9534e-08
-0.250133, 9.16856e-08
-0.240114, 9.4236e-08
-0.230105, 9.68188e-08
-0.220124, 9.94955e-08
-0.209916, 1.029e-07
-0.199945, 1.06165e-07
-0.189936, 1.09743e-07
-0.179946, 1.13666e-07
-0.169933, 1.17889e-07
-0.159933, 1.22754e-07
-0.149935, 1.27801e-07
-0.13994, 1.32442e-07
-0.129946, 1.35889e-07
-0.119951, 1.3854e-07
-0.109962, 1.43181e-07
-0.0999428, 1.51271e-07
-0.0899353, 1.63809e-07
-0.0799448, 1.81717e-07
-0.0699374, 2.06404e-07
-0.0599501, 2.39886e-07
-0.0499348, 2.85231e-07
-0.0399538, 3.46077e-07
-0.0299418, 4.2779e-07
-0.019971, 5.35696e-07
-0.00995084, 6.76006e-07
6.98973e-05, 8.53648e-07
0.0100411, 1.07042e-06
0.0200691, 1.32191e-06
0.0300721, 1.59445e-06
0.0400597, 1.87128e-06
0.0500578, 2.14781e-06
0.0600478, 2.4096e-06
0.0700721, 2.63066e-06
0.0800605, 2.78131e-06
0.0900536, 2.85082e-06
0.10003, 2.85434e-06
0.110047, 2.81009e-06
0.120037, 2.73606e-06
0.130052, 2.64413e-06
0.140037, 2.54442e-06
0.150043, 2.44762e-06
0.160053, 2.35385e-06
0.170044, 2.26846e-06
0.180049, 2.19158e-06
0.190023, 2.12188e-06
0.200039, 2.06156e-06
0.210036, 2.00622e-06
0.220038, 1.9587e-06
0.230064, 1.91544e-06
0.24005, 1.87702e-06
0.250051, 1.84314e-06
0.260048, 1.81216e-06
0.270049, 1.78538e-06
0.280035, 1.761e-06
0.290037, 1.73978e-06
0.30003, 1.72149e-06
0.310049, 1.70404e-06
0.320058, 1.69105e-06
0.330058, 1.67858e-06
0.340062, 1.66849e-06
0.350263, 1.6612e-06
0.360259, 1.65313e-06
0.370245, 1.64827e-06
0.380242, 1.64361e-06
0.390244, 1.6405e-06
0.400252, 1.63841e-06
0.410256, 1.63737e-06
0.420231, 1.63702e-06
0.430249, 1.636e-06
0.440239, 1.63545e-06
0.450244, 1.63491e-06
0.460239, 1.63375e-06
0.470221, 1.63334e-06
0.480236, 1.63211e-06
0.490241, 1.63087e-06
0.500226, 1.62959e-06
0.510216, 1.62744e-06
0.520214, 1.62584e-06
0.530238, 1.62359e-06
0.540245, 1.62131e-06
0.550243, 1.61973e-06
0.560224, 1.61788e-06
0.570233, 1.6172e-06
0.580224, 1.6168e-06
0.590234, 1.61749e-06
0.600212, 1.61764e-06
0.610217, 1.61873e-06
0.620161, 1.61835e-06
0.630156, 1.61822e-06
0.640185, 1.61901e-06
0.650172, 1.61829e-06
0.660178, 1.61973e-06
0.67016, 1.61989e-06
0.680175, 1.61939e-06
0.690152, 1.61909e-06
0.70015, 1.617e-06
0.710151, 1.61601e-06
0.720182, 1.61328e-06
0.730179, 1.61245e-06
0.740177, 1.61133e-06
0.750188, 1.61125e-06
0.760186, 1.61203e-06
0.770197, 1.61247e-06
0.780165, 1.61459e-06
0.790172, 1.61704e-06
0.800165, 1.62011e-06
0.810158, 1.62417e-06
0.820168, 1.62931e-06
0.830136, 1.6351e-06
0.840163, 1.64208e-06
0.850136, 1.65132e-06
0.860158, 1.66234e-06
0.870142, 1.67559e-06
0.880134, 1.6941e-06
0.890149, 1.71554e-06
0.90014, 1.74464e-06
0.91035, 1.78456e-06
0.920334, 1.83614e-06
0.930328, 1.91477e-06
0.940333, 2.02077e-06
0.950357, 2.15968e-06
0.960349, 2.33724e-06
0.970331, 2.55875e-06
0.980338, 2.81399e-06
0.990329, 3.08348e-06
1.00035, 3.33413e-06
1.01031, 3.53887e-06
1.02033, 3.67663e-06
1.03032, 3.74034e-06
1.04034, 3.7384e-06
1.05035, 3.69266e-06
1.06034, 3.61847e-06
1.07035, 3.53022e-06
1.08033, 3.43986e-06
1.09034, 3.35423e-06
1.10033, 3.27403e-06
1.11033, 3.20304e-06
1.12033, 3.13869e-06
1.13035, 3.08284e-06
1.14035, 3.03337e-06
1.15035, 2.99198e-06
1.16035, 2.95723e-06
1.17035, 2.92898e-06
1.18036, 2.90561e-06
1.19034, 2.88938e-06
1.20034, 2.87781e-06
1.21033, 2.87055e-06
1.22034, 2.86999e-06
1.23034, 2.87161e-06
1.2403, 2.88109e-06
1.25033, 2.89444e-06
1.26032, 2.91332e-06
1.27033, 2.93881e-06
1.28034, 2.96702e-06
1.29033, 3.00179e-06
1.30033, 3.04305e-06
1.3103, 3.08763e-06
1.32032, 3.1433e-06
1.3303, 3.20672e-06
1.3403, 3.28169e-06
1.35032, 3.3665e-06
1.36032, 3.46755e-06
1.37033, 3.57902e-06
1.38033, 3.70305e-06
1.39032, 3.84063e-06
1.40033, 3.98431e-06
1.41034, 4.13419e-06
1.4203, 4.28419e-06
1.43031, 4.42997e-06
1.44029, 4.56568e-06
1.45028, 4.69522e-06
1.46031, 4.81767e-06
1.47048, 4.94049e-06
1.48049, 5.0564e-06
1.49048, 5.17161e-06
1.50049, 5.28781e-06
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
$$ === CHEMSPECTRA CYCLIC VOLTAMMETRY ===
##$CSSCANRATE=0.09
##$CSSPECTRUMDIRECTION=NEGATIVE
##$CSCYCLICVOLTAMMETRYDATA=
(0.10003, 2.85434e-06, -1.5404, -3.07144e-06, 1.441336382491224, 1.64043, 0.380242, 1.64361e-06, 1)
(0.10002, 2.83434e-06, -1.5504, -3.17144e-06, 1.541336382491224, 1.54043, 0.480242, 1.74361e-06, 0)
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=RCV_LSH-R444_full+Fc
##JCAMP-DX=5.00
##DATA TYPE=CYCLIC VOLTAMMETRYPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=1.0
##MAXX=1.50049
##MAXY=5.34724e-06
##MINX=-1.9005
##MINY=-3.07144e-06
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=2
##PEAKTABLE= (XY..XY)
-1.5404, -3.07144e-06
1.49048, 5.34724e-06
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=RCV_LSH-R444_full+Fc
##JCAMP-DX=5.00
##DATA TYPE=CYCLIC VOLTAMMETRYPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=1.0
##MAXX=1.50049
##MAXY=5.34724e-06
##MINX=-1.9005
##MINY=-3.07144e-06
##NPOINTS=10
##PEAKTABLE= (XY..XY)
1.22034, 2.86999e-06
0.650172, 1.61829e-06
0.630156, 1.61822e-06
0.580224, 1.6168e-06
0.750188, 1.61125e-06
0.360257, 1.43418e-06
0.970335, 6.05514e-07
-0.94029, 1.30576e-08
0.0200669, -1.03802e-06
-1.5404, -3.07144e-06
##END=

##END=




`;

export default cyclicVoltaJcamp1;
